export const getCategories = ({ categoryReducer: { categories = [] } = {} }) => categories;
export const getCategoriesCount = ({ categoryReducer: { count = 0 } = {} }) => count;
export const getCategoriesFilter = ({ categoryReducer: { filter = {} } = {} }) => filter;
